export function Fact(props: { label: string; value: string; mono?: boolean }) {
  return (
    <div class="scan-fact">
      <dt>{props.label}</dt>
      <dd class={props.mono ? "mono" : ""}>{props.value}</dd>
    </div>
  );
}
